import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getLog, type LogRecord, type ServiceSlug } from "../api/client";

export interface UseLogOptions {
  serviceSlug: ServiceSlug | null;
  logId: string | null | undefined;
  refreshToken?: number;
  enabled?: boolean;
}

export interface UseLogResult {
  log: LogRecord | null;
  loading: boolean;
  error: string | null;
}

export function useLog({
  serviceSlug,
  logId,
  refreshToken = 0,
  enabled = true,
}: UseLogOptions): UseLogResult {
  const query = useQuery({
    queryKey: ["log", serviceSlug, logId, refreshToken],
    enabled: !!serviceSlug && !!logId && enabled,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getLog({ serviceSlug: serviceSlug!, logId: logId!, signal }),
  });

  if (!serviceSlug || !logId || !enabled) {
    return { log: null, loading: false, error: null };
  }

  const error =
    query.error instanceof Error ? query.error.message : query.error ? "Failed to load log" : null;
  return { log: query.data ?? null, loading: query.isLoading, error };
}
